import styled from 'styled-components';
import { theme } from '../../../../styles/theme';

const ModifiedIconDiv = styled.div<{ $isClickable?: boolean }>`
  font-weight: 600;
  font-size: 16px;
  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'default')};
  ${({ $isClickable }) =>
    $isClickable &&
    `
      :hover {
        color: ${theme.colors.mainBlue};
      }
    `}
`;

interface IProps {
  isClickable?: boolean;
}

// TODO this should go away once we get a better icon
const ModifiedIcon = ({ isClickable }: IProps) => {
  return <ModifiedIconDiv $isClickable={isClickable}>*</ModifiedIconDiv>;
};

export default ModifiedIcon;
